import React from 'react'
import moment from 'moment'
import { IntlProvider } from 'react-intl'
import { ConfigProvider } from '@lockerpm/design'
import { connect } from 'react-redux'

import vi_VN from '@lockerpm/design/es/locale/vi_VN'
import en_US from '@lockerpm/design/es/locale/en_US'
import zh_CN from '@lockerpm/design/es/locale/zh_CN'
import ru_RU from '@lockerpm/design/es/locale/ru_RU'
import fr_FR from '@lockerpm/design/es/locale/fr_FR'

import global from '../config/global'
import 'moment/locale/vi'

const getLocale = (v) => {
  if (v === global.constants.LANGUAGE.VI) {
    return {
      default: vi_VN
    }
  }
  if (v === global.constants.LANGUAGE.ZH) {
    return {
      default: zh_CN
    }
  }
  if (v === global.constants.LANGUAGE.RU) {
    return {
      default: ru_RU
    }
  }
  if (v === global.constants.LANGUAGE.FR) {
    return {
      default: fr_FR
    }
  }
  return {
    default: en_US
  }
}

const Locales = props => {
  const localeIntl = {
    locale: props.locale,
  }
  moment.locale(props.locale)
  
  return (
    <IntlProvider {...localeIntl}>
      <ConfigProvider
        locale={getLocale(props.locale).default}
      >
        {props.children}
      </ConfigProvider>
    </IntlProvider>
  )
}

export default connect(
  state => ({
    locale: state.system.locale,
  }),
  null
)(Locales)
